import Chart from "chart.js/auto";

import { grey } from "@mui/material/colors";

import { formatColumns } from "../../../../lib/Utility";

//LINEPLUGIN SI OCCUPA DI DISEGNARE UNA LINEA VERTICALE SUL GRAFICO CHE
///SI ALLINEA CON LA POSIZIONE CORRENTE DEL TOOLTIP.
export const linePlugin = () => {
  return {id: 'linePlugin',
    afterDatasetsDraw(chart) {
      if (chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
        const ctx = chart.ctx;
        const x = chart.tooltip.realX;
        const y_axis = chart.scales.y;
        const topY = y_axis.top;
        const bottomY = y_axis.bottom;

        // draw line
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 2;
        ctx.strokeStyle = grey[900];
        ctx.stroke();
        ctx.restore();
      }
    }
  };
}

export const tooltipPositionPlugin = (props) => {
  const {sizeMedia} = props
  const tooltipPlugin = Chart.registry.getPlugin("tooltip");

  tooltipPlugin.positioners.custom = function(elements) {
    const pos = tooltipPlugin.positioners.average(elements);

    // SE NON TROVA NIENTE
    if (pos === false) {
      return false;
    }

    const tooltip = this;
    const chartWidth = tooltip.chart.width;
    tooltip.realX = pos.x;

    const nOfColumns = formatColumns(elements);
    const tooltipWidth = 230 * nOfColumns;

    if (pos.x > chartWidth / 2) {
      return {
        x: sizeMedia ? 50 : -5,
        y: sizeMedia ? 0 : 300,
      };
    }

    return {
      x: sizeMedia ? (chartWidth - (tooltipWidth + 100)) : -5,
      y: sizeMedia ? 0 : 300,
    };
  };
}
